import type {ReactNode} from 'react';
import React from 'react'
import AioCheckbox from './AioCheckbox'
import css from './aio.less'
import AioLabel from './AioLabel'
import {arraySetChange, iterableIncludes} from '../../util/collections'
import type {CheckboxOption} from '../../types/shared-input-types'

export interface AioCheckboxListChangeEvent<T> {
    values: T[] | Set<T>
}

interface AioCheckboxListProps<T> {
    label: ReactNode
    noItems?: ReactNode
    options: CheckboxOption<T>[]
    required?: boolean
    columnWidth?: React.CSSProperties['columnWidth']
    values: T[] | Set<T>
    onChange: (ev: AioCheckboxListChangeEvent<T>) => void
}

export default function AioCheckboxList<T>({label, options, required, columnWidth, values, onChange, noItems}: AioCheckboxListProps<T>) {
    return (
        <div className={css.checkboxListWrapper}>
            <AioLabel required={required}>{label}</AioLabel>
            {options?.length ?
            <ul className={css.checkboxList} style={{columnWidth}}>
                {options.map((opt, idx) => {
                    const value: T = opt.value || opt.id as T
                    return (
                        <li key={(opt.key || opt.id || idx)}>
                            <AioCheckbox checked={iterableIncludes(values, value)} onChange={ev => onChange?.({values: arraySetChange(ev.target.checked, values, value)})}
                                         label={opt.label || opt.name}/>
                        </li>
                    )
                })}
            </ul> : (noItems ?? <>No items to display.</>)}
        </div>
    )
}

